// extracted by mini-css-extract-plugin
export var brand = "_2j-9";
export var button = "_2j-0";
export var chevron = "_2j-v";
export var chevronButton = "_2j-w";
export var content = "_2j-n";
export var danger = "_2j-g";
export var dangerOutlined = "_2j-h";
export var dark = "_2j-l";
export var darkTheme = "_2j-c";
export var extraSmall = "_2j-4";
export var fullWidth = "_2j-8";
export var ghost = "_2j-d";
export var gray = "_2j-t";
export var icon = "_2j-p";
export var iconButton = "_2j-s";
export var iconButtonBorder = "_2j-x";
export var iconButtonBorderDark = "_2j-y";
export var iconButtonBorderLight = "_2j-z";
export var iconLeft = "_2j-q";
export var iconRight = "_2j-r";
export var large = "_2j-1";
export var light = "_2j-m";
export var medium = "_2j-2";
export var micro = "_2j-5";
export var nano = "_2j-7";
export var outlined = "_2j-k";
export var pending = "_2j-a";
export var primary = "_2j-i";
export var shadow = "_2j-o";
export var small = "_2j-3";
export var solidLight = "_2j-e";
export var solidLightBrand = "_2j-f";
export var spinner = "_2j-u";
export var transparent = "_2j-j";
export var warning = "_2j-b";
export var wideNano = "_2j-6";